/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
class TimeClock implements MerchantosTimeClock {
  /**
   * Shows the clock_inout tab.
   * */
  public showClockInOut: MerchantosTimeClock['showClockInOut'] = () => {
    window.merchantos.tabs.show('clock_inout');
  };

  /**
   * Ensures the PIN is valid and submits the PIN to the clock_inout form.
   *
   * @params form {HTML Node} - The submitted HTML form.
   * @returns {Boolean} False - Always returns false to prevent default form
   *                            submission behavior.
   * */
  public submitPINForClockInOut: MerchantosTimeClock['submitPINForClockInOut'] = (form) => {
    const $submitPINButton = $('#clock-in-out-submit');

    // Return early if the pin isn't valid.
    if (this.isNotValidPIN()) {
      return false;
    }

    // Disable the submit button to prevent accidental multiple submissions.
    $submitPINButton.prop('disabled', true);

    window
      .doServerCall(this.buildTimeClockForm(form), this.cbClockInOut.bind(this))
      .always(function tcSumbitAlways() {
        $submitPINButton.prop('disabled', false);
      });
    return false;
  };

  /**
   * Checks if the entered PIN is valid before submission.  Currently
   * only ensures that the PIN field is not empty.
   *
   * @returns {Boolean} - whether or not the entered PIN is valid
   * */
  private isNotValidPIN = () => {
    const $pinError = $('#pin-error');

    if (!($('#clock_access_pin').val() as string).length) {
      $pinError.text('Please enter your employee PIN to clock in or out.');
      $pinError.show();
      return true;
    }
    $pinError.hide();
    return false;
  };

  /**
   * Builds the content map object based on the time clock form needed
   * by the doServerCall function.
   *
   * @params form {HTML Node} - The submitted HTML form.
   * @returns {Object} - time clock form key/values
   * */
  private buildTimeClockForm = (form: TSFixMe) => {
    const contentMap = {} as ContentMap;
    contentMap.method = 'POST';
    contentMap.form_name = 'clock_inout';
    const keyValues = window.getFormValues(form);
    if (keyValues) {
      for (const prop in keyValues) {
        // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        contentMap[prop] = keyValues[prop];
      }
    }

    return contentMap;
  };

  /**
   * Callback for the clock in/out request.
   * */
  private cbClockInOut = (result: TSFixMe) => {
    if (!result.pin_verified) {
      $('#clock_inout_tab').find('.autofocus').first().trigger('select');
      return;
    }

    $('#clock_access_pin').val('');

    window.merchantos.tabs.close();
    this.showClockInOut();
  };
}

window.merchantos.timeClock = new TimeClock();
